/* eslint-disable import/prefer-default-export */
import { I18n } from 'react-redux-i18n';

function allocationRules() {
  return [
    {
      number: 1,
      label: I18n.t('BEE4684' /* Alocação total do endereço */),
    },
    {
      number: 2,
      label: I18n.t('BEE4685' /* Alocação por embalagem fechada */),
    },
    {
      number: 3,
      label: I18n.t('BEE4686' /* Área de picking */),
    },
    {
      number: 4,
      label: I18n.t('BEE4687' /* Controle de validade (prioriza vencimento mais próximo) */),
    },
    {
      number: 5,
      label: I18n.t('BEE4688' /* Demais endereços */),
    },
    {
      number: 6,
      label: I18n.t('BEE4689' /* Filtro de validade mínima para saída */),
    },
    {
      number: 7,
      label: I18n.t('BEE4690' /* Prioridade da área de picking (apenas regras 1 a 3) */),
    },
    {
      number: 8,
      label: I18n.t('BEE4691' /* Quantidade obrigatória (múltiplos do valor configurado) */),
    },
    {
      number: 9,
      label: I18n.t('BEE4692' /* Quantidade mínima do item */),
    },
    {
      number: 10,
      label: I18n.t('BEE4693' /* Sobra mínima no endereço */),
    },
    {
      number: 11,
      label: I18n.t('BEE4694' /* Etiqueta seriada / múltiplo do fator de embalagem */),
    },
    {
      number: 12,
      label: I18n.t('BEE4695' /* Prioridade de depósito configurada no tipo de pedido */),
    },
    {
      number: 13,
      label: I18n.t('BEE4696' /* Endereço bloqueado ou com bloqueio de alocação */),
    },
    {
      number: 14,
      label: I18n.t('BEE4697' /* Saldo disponível */),
    },
    {
      number: 15,
      label: I18n.t('BEE4698' /* Lote sugerido no item do pedido */),
    },
    {
      number: 16,
      label: I18n.t('BEE4699' /* Combinação de endereços na simulação */),
    },
    {
      number: 17,
      label: I18n.t('BEE4700' /* Separação parcial de produção */),
    },
    {
      number: 18,
      label: I18n.t('BEE3315' /* Alocação Total do Pedido */),
    },
  ];
}

export default {
  allocationRules,
};
